import { useEffect } from "react";

/**
 * Globales „Overlay offen"-Signal (Antoine, 27.09.2026 - KI-Knopf-mobil): auf dem Handy soll das
 * lokale Stack-Auth-Entwicklerwerkzeug (der runde Knopf unten rechts, sichtbar nur auf localhost,
 * s. Kommentar in index.css) sich ausblenden, solange irgendein Drawer/Modal offen ist - es sitzt
 * sonst wegen `z-index: 2147483647` (Maximalwert) IMMER ueber jedem Overlay der App.
 *
 * Bewusst ein simpler Modul-Zaehler statt Context/Store: mehrere Overlays koennen gleichzeitig
 * offen sein (z. B. ein Bestaetigungs-Modal ueber einem schon offenen Drawer, `oben` in
 * `Modal`) - erst wenn WIRKLICH keins mehr offen ist, verschwindet das Attribut wieder.
 */
let offeneOverlays = 0;

export function useOverlayOpenSignal(open: boolean): void {
  useEffect(() => {
    if (!open) return;
    offeneOverlays += 1;
    document.documentElement.setAttribute("data-overlay-open", "");
    return () => {
      offeneOverlays = Math.max(0, offeneOverlays - 1);
      if (offeneOverlays === 0) document.documentElement.removeAttribute("data-overlay-open");
    };
  }, [open]);
}
